// extracted by mini-css-extract-plugin
module.exports = {"content":"Launch_content__dj7Mb","heading":"Launch_heading__2xYG9","downloadText":"Launch_downloadText__PQLU2","launch":"Launch_launch__GAy7t","buttons":"Launch_buttons__1dm9v"};